export default __webpack_public_path__ + "static/media/Clinical-Trials-01.97c36510.jpg";